import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';
import clsx from 'clsx';
import BlockIcon from '@material-ui/icons/Block';
import FrameImg from '../../assets/icons/Frame16632.png';
import Frame1647 from '../../assets/icons/Frame1647.png';
import Frame35529 from '../../assets/icons/Frame35529.png';
import Frame35530 from '../../assets/icons/Frame35530.png';
import Frame35531 from '../../assets/icons/Frame35531.png';
import Frame35532 from '../../assets/icons/Frame35532.png';
import Frame35533 from '../../assets/icons/Frame35533.png';
import Frame35534 from '../../assets/icons/Frame35534.png';
import Frame35535 from '../../assets/icons/Frame35535.png';
import Frame35536 from '../../assets/icons/Frame35536.png';
import Frame35537 from '../../assets/icons/Frame35537.png';
import Frame35538 from '../../assets/icons/Frame35538.png';
import FrameRed from '../../assets/icons/FrameRed.png';



import Select from '@material-ui/core/Select';

import { useStyles } from './CardStyle';

export default function Card() {
    const classes = useStyles();
    const [age, setAge] = React.useState('');
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    return (
        <div >
            <Grid container spacing={2} className={classes.gridContainer}>
                {/* 1 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={clsx(classes.paper , classes.cardBorder)}>
                        <img src={FrameImg} className={classes.image} alt='img' />
                        <div className={classes.cardBody}>
                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>PostgreSQL®</p>
                                <p className={classes.line}>{'|'}</p>
                                <Select
                                    classes={{ root: classes.focusSelect }}
                                    className={classes.select}
                                    disableUnderline
                                    native
                                    value={age}
                                    onChange={handleChange}
                                    inputProps={{
                                        name: 'age',
                                        id: 'age-native-simple',
                                    }}
                                >
                                   
                                    <option value={10}>Version 3.1</option>
                                    <option value={10}>Version 3.2</option>

                                </Select>
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>

                    </Paper>
                </Grid>
                {/* 2 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={Frame1647} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>PostgreSQL®</p>
                                <p className={classes.line}>{'|'}</p>
                                <Select
                                    className={classes.select}
                                    disableUnderline
                                    native
                                    value={age}
                                    onChange={handleChange}
                                    inputProps={{
                                        name: 'age',
                                        id: 'age-native-simple',
                                    }}
                                >
                                    <option value={10}>Version 3.1</option>
                                    <option value={10}>Version 3.2</option>
                                </Select>
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>
                    </Paper>
                </Grid>
                {/* 3 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={Frame35529} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>MySQL®</p>

                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>
                    </Paper>
                </Grid>
                {/* 4 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                <Paper className={classes.paper}>
                        <img src={Frame35530} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>Elasticsearch®</p>
                                <p className={classes.line}>{'|'}</p>
                                <Button variant="outlined" disableRipple={true}
                                startIcon={<BlockIcon  style={{color: '#824ED2' , fontSize: '10px'}} />}
                                className={classes.cardBtn}>
                                    Unavailable
                                </Button>
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>
                    </Paper>
                </Grid>
                {/* 5 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={Frame35531} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>PostgreSQL®</p>
                               
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>

                    </Paper>
                </Grid>
                {/* 6 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={FrameRed} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>MySQL®</p>
                                <p className={classes.line}>{'|'}</p>
                                <Select
                                    className={classes.select}
                                    disableUnderline
                                    native
                                    value={age}
                                    onChange={handleChange}
                                    inputProps={{
                                        name: 'age',
                                        id: 'age-native-simple',
                                    }}
                                >
                                    <option value={10}>Version 3.1</option>
                                    <option value={10}>Version 3.2</option>
                                </Select>
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>

                    </Paper>
                </Grid>
                {/* 7 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={Frame35532} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>Elasticsearch®</p>                              
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>

                    </Paper>
                </Grid>
                {/* 8 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={Frame35533} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>PostgreSQL®</p>
                               
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>

                    </Paper>
                </Grid>
                {/* 9 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={Frame35534} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>MySQL®</p>
                                
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>

                    </Paper>
                </Grid>
                {/* 10 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={Frame35535} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>Elasticsearch®</p>
                                <p className={classes.line}>{'|'}</p>
                                <Select
                                    className={classes.select}
                                    disableUnderline
                                    native
                                    value={age}
                                    onChange={handleChange}
                                    inputProps={{
                                        name: 'age',
                                        id: 'age-native-simple',
                                    }}
                                >
                                      <option value={10}>Version 3.1</option>
                                    <option value={10}>Version 3.2</option>
                                </Select>
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>

                    </Paper>
                </Grid>
                {/* 11 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={Frame35536} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>PostgreSQL®</p>
                                <p className={classes.line}>{'|'}</p>
                                <Select
                                    className={classes.select}
                                    disableUnderline
                                    native
                                    value={age}
                                    onChange={handleChange}
                                    inputProps={{
                                        name: 'age',
                                        id: 'age-native-simple',
                                    }}
                                >
                                      <option value={10}>Version 3.1</option>
                                    <option value={10}>Version 3.2</option>
                                </Select>
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>

                    </Paper>
                </Grid>
                {/* 12 */}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={Frame35537} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>MySQL®</p>
                                <p className={classes.line}>{'|'}</p>
                                <Button variant="outlined" disableRipple={true}
                                className={classes.cardBtnTwo}>
                                    Beta
                                </Button>
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>

                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                    <Paper className={classes.paper}>
                        <img src={Frame35538} className={classes.image} alt='img' />

                        <div className={classes.cardBody}>

                            <div className={classes.cardHead}>
                                <p className={classes.cardHeadText}>Elasticsearch®</p>
                                <p className={classes.line}>{'|'}</p>
                                <Button variant="outlined" disableRipple={true}
                                className={classes.cardBtnTwo}>
                                    Beta
                                </Button>
                            </div>
                            <p className={classes.cardText}>Kafka- High-Throughput<br /> Distributed Messaging System</p>
                        </div>

                    </Paper>
                </Grid>
                
            </Grid>
        </div>
    );
}
